// extracted by mini-css-extract-plugin
export default {"link":"Rewards_link__B4GPs","no_hover":"Rewards_no_hover__wBfjL"};